<template>
  <div class="overflow-hidden">
    <h1 class="mt0 ttu" style="margin: .67em 0; font-size: 2em">
      {{this.isEnglish ? 'today on tap' : 'dnes na&nbsp;výčape'}}
      <span class="smp-dark-green">
        {{ today.getDate() }}.<smp-hair />{{ months[today.getMonth()] }}
      </span>
    </h1>

    <div class="mt4">
      <template v-for="beersByCategory in beersByCategories">
        <div class="mt4 pt1">
          <h2 class="f1 gold">{{ isEnglish ? beersByCategory.category.nameEn : beersByCategory.category.name }}</h2>
          <smp-beer-item
            v-for="(beer, i) in beersByCategory.beers"
            :key="beer['.key']"
            :beer="beer"
            :class="{ mt3: i != 0 }"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import SmpBeerItem from '@/components/BeerItem'
import {beersByCategory, compareByRemainingBeers, setKegData} from '@/utils/beer'
import {arrayToMap} from '@/utils'


export default {
    components: {
      SmpBeerItem,
    },

    props: {
      beers: Array,
      months: Array,
      isEnglish: Boolean,
    },

    data() {
      return {
        today: window.today,
        beerTypes: [...__INITIAL_STATE__.beerTypes],
        beerCategories: [...__INITIAL_STATE__.beerCategories],
        breweriesMap: arrayToMap(__INITIAL_STATE__.breweries, '.key'),
      }
    },

    computed: {
      beersComputed () {
        return [...this.beers]
          .map(setKegData)
          .sort(compareByRemainingBeers)
      },

      beersByCategories () {
        return this.beerCategories.map(x => ({
          category: x,
          beers: beersByCategory(this.beersComputed, this.beerTypes, x['.key'])
        })).filter(x => x.beers.length > 0)
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/BeersOnTap.vue?4f71f234